export default {"src":"/_next/static/media/spinner-third.50664363.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};